import { UsersTokenComponent } from '../../shared/components/users-token/users-token.component.js';
import './token.styles.css';

class TokenPage {
  render() {
    const container = document.getElementById('app');
    container.innerHTML = '';
    new UsersTokenComponent(container);
  }
}

export const componentToken = new TokenPage();
